import React, { useEffect, useState, useCallback } from "react";
import { Grid } from "@material-ui/core";
import { connect } from "react-redux";
import BaseWindow from "./public/BaseWindow";
import { usePlatformWaitingStyles } from "../styles/styles";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom";
import { getLimitDetails } from "../store/limitAndPaymentInformation/thunkActions";
import { bindActionCreators } from "redux";
import { getDDMMYYYYFromYYYYMMDD, getNumberFormat } from "../utils/enums";

function PlatformWaiting(props) {
  let history = useHistory();
  let { uuid } = useParams();
  const [limitInfo, setLimitInfo] = useState(null);
  const [countdown, setCountdown] = useState(15);
  const [progress, setProgress] = useState(100);

  const classes = usePlatformWaitingStyles();

  const fetchLimitDetails = useCallback(() => {
    if (!uuid) return;

    props.actions
      .getLimitDetails({ externalId: uuid }, history)
      .then((response) => {
        if (response?.data) {
          setLimitInfo(response.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching limit details:", error);
      });
  }, [uuid, props.actions.getLimitDetails, history]);

  useEffect(() => {
    fetchLimitDetails();

    const totalTime = 15; // Total countdown time in seconds
    const timer = setInterval(() => {
      setCountdown((prev) => {
        const newTime = prev > 0 ? prev - 1 : 0;
        setProgress((newTime / totalTime) * 100); // Update progress
        return newTime;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [fetchLimitDetails]);

  useEffect(() => {
    if (countdown === 0) {
      window.location.href = limitInfo?.callbackUrl
        ? limitInfo.callbackUrl
        : "unsuccess"; // Redirect logic
    }
  }, [countdown]);

  return (
    <BaseWindow>
      <Grid container direction="column" alignItems="center">
        <Grid item xs={12} style={{ marginBottom: "20px" }}>
          <h2 className={classes.title}>Fibabanka Ticari Kredi</h2>
          <p className={classes.description}>
            Tebrikler! <b>Fibabanka Alışveriş Kredisi</b> ile ödemeniz
            onaylandı.
          </p>
          {limitInfo?.isLimitIncluded === "1" && (
            <p className={classes.limitInfo}>
              <b>{getDDMMYYYYFromYYYYMMDD(limitInfo.limitEndDate)}</b> tarihine
              kadar <b>{limitInfo.companyCode}</b> alışverişlerinde
              kullanabileceğiniz{" "}
              <b>{getNumberFormat(limitInfo.remainedLimit)} TL</b> daha
              limitiniz olduğunu hatırlatırız.
            </p>
          )}
        </Grid>

        <Grid
          container
          item
          xs={12}
          style={{ marginBottom: "30px" }}
          alignItems="center"
        >
          <div className={classes.greyBox}>
            <p className={classes.infoText}>
              <b>
                {props.unsuccess.msg && props.unsuccess.msg !== ""
                  ? props.unsuccess.msg
                  : "Fibabanka Ticari Kredi ile alışverişinizi tamamlamak için:"}
              </b>
            </p>
            <ul className={classes.list}>
              <li>
                SMS'teki linke tıklayarak Fibabanka Kurumsal Mobil'i indirin.
              </li>
              <li>
                "Müşteri Olmak İstiyorum" butonuna tıklayın ve müşterimiz olun.
              </li>
              <li>
                "Bekleyen Onaylar" menüsünden kredi dokümanlarınızı onaylayın,
                kredinizi anında kullanın.
              </li>
            </ul>
          </div>
        </Grid>

        <Grid item xs={12}>
          <div className={classes.circle}>
            <svg viewBox="0 0 36 36" className={classes.svg}>
              <path
                d="M18 2a16 16 0 1 1 0 32 16 16 0 1 1 0-32"
                fill="none"
                stroke="#e0e0e0"
                strokeWidth="2"
              />
              <path
                d="M18 2a16 16 0 1 1 0 32 16 16 0 1 1 0-32"
                fill="none"
                stroke="#4CAF50"
                strokeWidth="2"
                strokeDasharray="100"
                strokeDashoffset={100 - progress}
                strokeLinecap="round"
              />
            </svg>
            <div className={classes.textContainer}>
              <span className={classes.countdownText}>{countdown}</span>
              <span className={classes.saniyeText}>Saniye</span>
            </div>
          </div>
          <p className={classes.redirectText}>
            {limitInfo?.companyCode} sayfasına yönlendiriliyorsunuz...
          </p>
        </Grid>
      </Grid>
    </BaseWindow>
  );
}

const mapStateToProps = (state) => {
  return {
    unsuccess: state.unsuccess,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      getLimitDetails: bindActionCreators(getLimitDetails, dispatch),
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlatformWaiting);
